import { first } from 'lodash'
import { api, wpapi } from './Axios'

export const SWRFecther = (url) => api.get(url).then((res) => res.data.data)

export const GeneralAPI = {
    async getHead(url) {
        return await api.get(`yoast/v1/get_head?url=${url}`)
    },

    async getACF(slug) {
        const { data } = await api.get(`wp/v2/product/?slug=${slug}`)
        return first(data).acf
    },

    async getDefaultAttributes(slug) {
        const { data } = await api.get(`wp/v2/product/?slug=${slug}`)
        return first(data).default_templates_attributes
    },

    getACFOptions(name) {
        return api.get(`/acf/v3/options/${name}`)
    },

    async getACFProductsPage() {
        const { data } = await this.getACFOptions('options/products')
        return data.products
    },

    async getACFBanners() {
        const { data } = await this.getACFOptions('options/banners')
        return data
    },

    async getACFAddonProductIds() {
        return (await this.getACFAddonProducts()).map(({ product }) => product)
    },

    getPage() {
        return wpapi.pages().slug('/').get()
    },

    getPageBySlug(slug) {
        return wpapi.pages().slug(slug).get()
    },

    getPageById(id) {
        return wpapi.pages().id(id).get()
    },

    getMediaByid(id) {
        return wpapi.media().id(id).get()
    },

    // @TODO to make this one dynamic too, create new end point in wp or fetch setting first from /settings
    async getFrontPage() {
        return await wpapi.pages().id(273).get()
    },

    // @TODO to make this one dynamic too, create new end point in wp or fetch setting first from /settings
    async getCartPage() {
        return await wpapi.pages().slug('/cart').get()
    },
}
